import { render, staticRenderFns } from "./buildPlatform.vue?vue&type=template&id=029f2f3c&scoped=true&"
import script from "./buildPlatform.vue?vue&type=script&lang=js&"
export * from "./buildPlatform.vue?vue&type=script&lang=js&"
import style0 from "./buildPlatform.vue?vue&type=style&index=0&id=029f2f3c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029f2f3c",
  null
  
)

export default component.exports